import newRequest from '@/utils/request'
// 获取个股详情持仓市值、持股占流通比、净买量
export function chartInfo ( query ) {
    return newRequest( {
        url: '/bxzj/ggtj',
        method: 'get',
        params: query
    } )
}
// 个股详情港资持股机构
export function getcgjg ( query ) {
    return newRequest( {
        url: '/integration/geGuHolderl',
        method: 'get',
        params: query
    } )
}

// 机构持仓概览
export function jiGouHolderl ( query ) {
    return newRequest( {
        url: '/integration/jiGouHolderl',
        method: 'get',
        params: query
    } )
}

// 机构持仓偏好
export function jiGouPrefer ( query ) {
    return newRequest( {
        url: '/integration/jiGouPrefer',
        method: 'get',
        params: query
    } )
}

// 持股明细
export function jiGouDetail ( query ) {
    return newRequest( {
        url: '/integration/jiGouDetail',
        method: 'get',
        params: query
    } )
}


// 获取机构持仓市值模块上证指数数据
export function getYunSpj ( query ) {
    return newRequest( {
        url: '/lssj/getYunSpj',
        method: 'get',
        params: query
    } )
}

// 获取板块数据
export function getBanKuaiTj ( query ) {
    return newRequest( {
        url: '/Integration/getBanKuaiTj',
        method: 'get',
        params: query
    } )
}

// 个股-港资机构
export function getStkHolder (query) {
    return newRequest({
        url: 'integration/geguholderl',
        method: 'get',
        params: query
    })
}

// 个股-港资机构-持股变化历史图
export function getStkHolderchg (query) {
    return newRequest({
        url: 'integration/geguholderchg',
        method: 'get',
        params: query
    })
}

// 个股-港资机构-增仓阶段统计
export function getStkHolderstat (query) {
    return newRequest({
        url: 'integration/geguholderstat',
        method: 'get',
        params: query
    })
}

// 北向资金 机构-持仓市值曲线
export function getHolderValue ( query ) {
    return newRequest( {
        url: '/Integration/getHolderValue',
        method: 'get',
        params: query
    } )
}